import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Progress,
  Row,
  Col,
  Alert,
} from "reactstrap";
import { Link } from "react-router-dom";
import { get } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import avatar from "../../../assets/images/personPlaceholder.png";
import SimpleBar from "simplebar-react";
import Placeholder from "../../../assets/images/Placeholder.gif";
const MostLovedGyms = () => {
  const [gyms, setGyms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMostLovedGyms = async () => {
    try {
      setLoading(true);
      const response = await get(
        `${endpoints.gym}/mostfavourite?filter=favourite`
      );
      console.log(response.data?.data);
      if (response.data) {
        setGyms(response.data.data);
      }
    } catch (err) {
      console.error(err);
      setError("Failed to load gyms. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMostLovedGyms();
  }, []);

  return (
    <Card
      className="rounded-4 visited-gyms-card mb-2 overflow-hidden"
      style={{ height: "350px" }}
    >
      <SimpleBar style={{ maxHeight: "300px" }}>
        <CardBody>
          <Row>
            <Col>
              <CardTitle className="ff-sora font-size-16 primary-black fw-normal">
                Most Loved Gyms
              </CardTitle>
            </Col>
            <Col className="text-end">
              <span className="ff-sora font-size-16 secondary-black fw-bold">
                <Link
                  to={{
                    pathname: "/list-gyms",
                    search: "?type=MOSTLOVED",
                    state: { selectedTags: "MOSTLOVED" },
                  }}
                  className="ff-sora font-size-16 secondary-black fw-bold"
                >
                  View All
                </Link>
              </span>
            </Col>
          </Row>
          {loading ? (
            <div className="d-flex justify-content-center align-items-center">
              <div
                className="spinner-border"
                style={{
                  width: "3rem",
                  height: "3rem",
                  color: "#3BABA6",
                }}
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : error ? (
            <Alert
              color="danger"
              className="text-center ff-sora font-size-14 secondary-black fw-normal"
            >
              {error}
            </Alert>
          ) : gyms.length === 0 ? (
            <>
              <tr>
                <td
                  colSpan="8"
                  className="text-center ff-sora font-size-16 fw-normal"
                >
                  <img
                    src={Placeholder}
                    alt={`logo`}
                    className="object-fit-contain image-fluid h-25 w-25 rounded-3 me-2"
                  />
                </td>
              </tr>
              <tr>
                <td
                  colSpan="8"
                  className="text-center border-0 ff-sora font-size-16 fw-normal"
                >
                  No Record Found!
                </td>
              </tr>
            </>
          ) : (
            gyms.map((gym, index) => (
              <Row
                key={gym._id + index}
                className="gym-row align-items-center mb-1"
              >
                <Col xs="2" sm="2" md="2">
                  <img
                    src={
                      gym.gymInfo?.files && gym.gymInfo.files.length
                        ? `${process.env.REACT_APP_IMG_URL}${
                            gym.gymInfo.files.find(
                              (val) => val.type === "image"
                            )?.data || avatar
                          }`
                        : avatar
                    }
                    alt={gym.gymInfo?.name || "Gym"}
                    className="gym-image object-fit-cover rounded-2"
                    height={40}
                    width={40}
                  />
                </Col>
                <Col xs="6">
                  <Progress
                    value={gym.percentage}
                    color="light"
                    className="gym-progress rounded-2 position-relative"
                    style={{
                      height: "40px",
                      backgroundColor: "transparent",
                    }}
                  />

                  <span
                    className="gym-name position-absolute ff-sora font-size-14 secondary-black fw-normal"
                    style={{
                      top: "10%",
                      left: "10%",
                    }}
                  >
                    {gym.gymInfo?.name?.split(" ").slice(0, 2).join(" ") +
                      (gym.gymInfo?.name.split(" ").length > 2 ? "..." : "")}
                    <br />
                    {gym?.address?.split(" ").slice(0, 2).join(" ") +
                      (gym?.address?.split(" ").length > 2 ? "..." : "")}
                  </span>
                </Col>

                <Col xs="4" className="text-right">
                  <span className="ff-sora font-size-14 light-black fw-normal">
                    {gym.percentage?.toFixed(2) || 0}%
                  </span>
                </Col>
              </Row>
            ))
          )}
        </CardBody>
      </SimpleBar>
    </Card>
  );
};

export default MostLovedGyms;
